import { irisTrackerService } from 'packages/common/services';

const origin = 'PERSONNEL_DEPARTMENT';
const catalogName = 'personnelDepartment';

export const clickSaveRegistrationServiceTakerAllocationTracker = (properties = {}) => {
  const catalog = irisTrackerService.getCatalog(catalogName);
  return irisTrackerService.buildTracker({
    catalog,
    view: catalog.views.serviceTakerAllocationRollover,
    origin,
  }).setAction(catalog.actions.clickSaveRegistrationServiceTakerAllocation)
    .setAdditionalInfo({ ...properties })
    .send();
};

export const clickSaveEditionServiceTakerAllocationTracker = (properties = {}) => {
  const catalog = irisTrackerService.getCatalog(catalogName);
  return irisTrackerService.buildTracker({
    catalog,
    view: catalog.views.serviceTakerAllocationRollover,
    origin,
  }).setAction(catalog.actions.clickSaveEditionServiceTakerAllocation)
    .setAdditionalInfo({ ...properties })
    .send();
};
